var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var RevenueEntry_1;
import { add, } from "@pentacode/openapi";
import { Exclude, Type } from "class-transformer";
import { Column, CreateDateColumn, DeleteDateColumn, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, Unique, UpdateDateColumn, } from "typeorm";
import { getCurrentContract, getDefaultSalary, getFirstContract, getLatestContract, getNominalWeeklyHours, hasFixedWorkDays, isActiveOn, } from "./contract.util";
import { TransformDateProperties } from "./encoding";
import { Account, BillingInfo, EmailTemplate, EmployeePayrollData, EmployeeTag, WageType } from "./entities";
import { matchesFilters, matchesTimeFilter } from "./filters";
import { getHolidayForDate, HOLIDAYS } from "./holidays";
import { Localized } from "./localized";
import { AbsenceAccountingSalaryConfig, AccountingSettings, BonusAccountingSalaryConfig } from "./model.embedded";
import { availabilityColor, availabilityIcon, availabilityLabel, repeatsLabel } from "./model.functions";
import { AbsenceMode, AbsenceStatus, AvailabilityStatus, BonusCompType, BonusLegalType, BonusTypeMode, BreakMode, BreakTiming, CompanyStatus, DocumentOrigin, EmployeeStatus, EmploymentType, Feature, Gender, JobApplicationStatus, JobPostingStatus, MealsMode, MimeType, NominalHoursMode, Repeat, RevenueType, Role, StaffAppFeature, TaxKey, VacationIncrement, VacationPolicy, } from "./model.types";
import { day, overlap } from "./time";
import { TimeEntryType } from "./time-entries/time-entry-type";
import { checkCondition, dateAdd, formatDate, FormStatus, getAllContractsForRange, getContractForDate, getContractForRange, getCostCenter, getDepartment, getEffectiveStatus, getEmployeeName, getPosition, getPositionColor, getTimeEntryColor, getTimeSettings, getVenue, getWageTypeSet, isAdult, parseDateString, parseTimes, toDateString, } from "./utils";
import { WageTypeDTO } from "./api/rpc";
const defaultAutoBreaks = [
    { duration: 6, amount: 0.5 },
    { duration: 9, amount: 0.75 },
];
let TimeSettings = class TimeSettings {
    constructor(vals = {}) {
        this.trackingEnabled = true;
        this.applyEarlyCheckin = false;
        this.applyLateCheckout = false;
        this.checkinWindow = 0.5;
        this.checkoutWindow = 11;
        this.checkinRounding = 5;
        this.checkoutRounding = -5;
        this.breakMode = BreakMode.Auto;
        this.breakTiming = BreakTiming.Start;
        this.unplannedCheckins = true;
        this.trackerDisplayEmployeeInfo = false;
        this.trackerDisplayRoster = true;
        this.trackerDisplayShiftDetails = false;
        /** @deprecated as of v1.25.0 */
        this.autoMeals = 0;
        this.mealsMode = MealsMode.Manual;
        this.mealEnabledBreakfast = false;
        this.mealStartBreakfast = null;
        this.mealEndBreakfast = null;
        this.mealEnabledLunch = true;
        this.mealStartLunch = "00:00:00";
        this.mealEndLunch = "24:00:00";
        this.mealEnabledDinner = false;
        this.mealStartDinner = null;
        this.mealEndDinner = null;
        this.mealsMinDuration = 0;
        this.autoBreaks = defaultAutoBreaks;
        this.paidBreaksAuto = false;
        this.paidBreaksManual = false;
        this.trackingViaAppEnabled = false;
        this.trackingViaAppRequiresToken = true;
        this.loggingRequiresPhotoFor = [];
        this.loggingRequiresLocation = false;
        this.order = 0;
        this.filters = [];
        /** @deprecated */
        this.bonusNight1Start = "20:00:00";
        /** @deprecated */
        this.bonusNight1End = "06:00:00";
        /** @deprecated */
        this.bonusNight2Start = "00:00:00";
        /** @deprecated */
        this.bonusNight2End = "04:00:00";
        /** @deprecated */
        this.bonusMinDuration = 0;
        /** @deprecated */
        this.bonusSundayNextDayUntil = "04:00:00";
        /* @deprecated */
        this.bonusHolidayNextDayUntil = "04:00:00";
        /* @deprecated */
        this.bonusChristmasEveFrom = "14:00:00";
        /* @deprecated */
        this.bonusNewYearsEveFrom = "14:00:00";
        Object.assign(this, vals);
    }
    getBreakfastInterval(date = toDateString(new Date())) {
        return (this.mealEnabledBreakfast &&
            this.mealStartBreakfast &&
            this.mealEnabledBreakfast &&
            parseTimes(date, this.mealStartBreakfast, this.mealEndBreakfast));
    }
    getLunchInterval(date = toDateString(new Date())) {
        return (this.mealEnabledLunch &&
            this.mealStartLunch &&
            this.mealEnabledLunch &&
            parseTimes(date, this.mealStartLunch, this.mealEndLunch));
    }
    getDinnerInterval(date = toDateString(new Date())) {
        return (this.mealEnabledDinner &&
            this.mealStartDinner &&
            this.mealEnabledDinner &&
            parseTimes(date, this.mealStartDinner, this.mealEndDinner));
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], TimeSettings.prototype, "id", void 0);
__decorate([
    ManyToOne("CompanySettings", "availableSettings", { eager: false })
    // to avoid cyclical dependencies
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    __metadata("design:type", Object)
], TimeSettings.prototype, "companySettings", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TimeSettings.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], TimeSettings.prototype, "companySettingsId", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackingEnabled", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "applyEarlyCheckin", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "applyLateCheckout", void 0);
__decorate([
    Column("float", { default: 0.5 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkinWindow", void 0);
__decorate([
    Column("float", { default: 11 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkoutWindow", void 0);
__decorate([
    Column("int", { default: 5 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkinRounding", void 0);
__decorate([
    Column("int", { default: -5 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "checkoutRounding", void 0);
__decorate([
    Column("int", { default: BreakMode.Auto }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "breakMode", void 0);
__decorate([
    Column("varchar", { default: BreakTiming.Start }),
    __metadata("design:type", String)
], TimeSettings.prototype, "breakTiming", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "unplannedCheckins", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackerDisplayEmployeeInfo", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackerDisplayRoster", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackerDisplayShiftDetails", void 0);
__decorate([
    Column("int", { default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "autoMeals", void 0);
__decorate([
    Column("varchar", { default: MealsMode.Manual }),
    __metadata("design:type", String)
], TimeSettings.prototype, "mealsMode", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "mealEnabledBreakfast", void 0);
__decorate([
    Column("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealStartBreakfast", void 0);
__decorate([
    Column("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealEndBreakfast", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "mealEnabledLunch", void 0);
__decorate([
    Column("time", { nullable: true, default: "00:00:00" }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealStartLunch", void 0);
__decorate([
    Column("time", { nullable: true, default: "24:00:00" }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealEndLunch", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "mealEnabledDinner", void 0);
__decorate([
    Column("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealStartDinner", void 0);
__decorate([
    Column("time", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TimeSettings.prototype, "mealEndDinner", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "mealsMinDuration", void 0);
__decorate([
    Column("simple-json", { default: JSON.stringify(defaultAutoBreaks) }),
    __metadata("design:type", Array)
], TimeSettings.prototype, "autoBreaks", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "paidBreaksAuto", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "paidBreaksManual", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackingViaAppEnabled", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "trackingViaAppRequiresToken", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], TimeSettings.prototype, "loggingRequiresPhotoFor", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], TimeSettings.prototype, "loggingRequiresLocation", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "order", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], TimeSettings.prototype, "filters", void 0);
__decorate([
    Column("time", { default: "20:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight1Start", void 0);
__decorate([
    Column("time", { default: "06:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight1End", void 0);
__decorate([
    Column("time", { default: "00:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight2Start", void 0);
__decorate([
    Column("time", { default: "04:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNight2End", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], TimeSettings.prototype, "bonusMinDuration", void 0);
__decorate([
    Column("time", { default: "04:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusSundayNextDayUntil", void 0);
__decorate([
    Column("time", { default: "04:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusHolidayNextDayUntil", void 0);
__decorate([
    Column("time", { default: "14:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusChristmasEveFrom", void 0);
__decorate([
    Column("time", { default: "14:00:00" }),
    __metadata("design:type", String)
], TimeSettings.prototype, "bonusNewYearsEveFrom", void 0);
TimeSettings = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], TimeSettings);
export { TimeSettings };
/**
 * Unassigned entries resolve to this synthetic draft rule set instead of any configured one: which
 * rules apply is unknown until an employee is assigned, so nothing may be derived from a rule set —
 * most importantly no mirrored final times (tracking stays enabled).
 */
export const DRAFT_TIME_SETTINGS = Object.freeze(new TimeSettings({ name: "Draft" }));
export const defaultNotificationSettings = {
    vacationRequests: { email: true, pushDesktop: true, pushMobile: true, filters: [] },
    sickNotes: { email: true, pushDesktop: true, pushMobile: true, filters: [] },
};
let CompanySettings = class CompanySettings {
    constructor(vals = {}) {
        this.startPayrollPeriod = 1;
        this.nominalHoursMode = NominalHoursMode.WeekFactor;
        this.iterativeBreaks = false;
        this.includeTaxedBonusesInBalance = false;
        this.weekFactor = 4.35;
        this.mealValueBreakfast = null;
        this.mealValueLunch = null;
        this.mealValueDinner = null;
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], CompanySettings.prototype, "id", void 0);
__decorate([
    Type(() => TimeSettings),
    OneToOne(() => TimeSettings, { nullable: true, cascade: false, eager: true, onDelete: "SET NULL" }),
    JoinColumn(),
    __metadata("design:type", TimeSettings)
], CompanySettings.prototype, "time", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "timeId", void 0);
__decorate([
    Column(() => AccountingSettings),
    __metadata("design:type", AccountingSettings)
], CompanySettings.prototype, "accounting", void 0);
__decorate([
    Column("date", { nullable: true }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "startLedgers", void 0);
__decorate([
    Column({ default: 1 }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "startPayrollPeriod", void 0);
__decorate([
    Column("int", { default: NominalHoursMode.WeekFactor }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "nominalHoursMode", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], CompanySettings.prototype, "iterativeBreaks", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], CompanySettings.prototype, "includeTaxedBonusesInBalance", void 0);
__decorate([
    Column("date", { default: "2021-01-01" }),
    __metadata("design:type", String)
], CompanySettings.prototype, "startUsingDailyAverage", void 0);
__decorate([
    Column("date", { default: "2022-01-01" }),
    __metadata("design:type", String)
], CompanySettings.prototype, "startUsingMoreAccurateAverage", void 0);
__decorate([
    OneToMany(() => TimeSettings, (s) => s.companySettings, { eager: true }),
    Type(() => TimeSettings),
    __metadata("design:type", Array)
], CompanySettings.prototype, "availableTimeSettings", void 0);
__decorate([
    Column("date", { nullable: true, default: null }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "commitTimeEntriesBefore", void 0);
__decorate([
    Column("float", { default: 4.35 }),
    __metadata("design:type", Number)
], CompanySettings.prototype, "weekFactor", void 0);
__decorate([
    Column("float", { nullable: true, default: 2 }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "mealValueBreakfast", void 0);
__decorate([
    Column("float", { nullable: true, default: 3.8 }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "mealValueLunch", void 0);
__decorate([
    Column("float", { nullable: true, default: 3.8 }),
    __metadata("design:type", Object)
], CompanySettings.prototype, "mealValueDinner", void 0);
CompanySettings = __decorate([
    Entity()
    /**
     * @class CompanySettings
     */
    ,
    __metadata("design:paramtypes", [Object])
], CompanySettings);
export { CompanySettings };
let AccountingSalaryConfig = class AccountingSalaryConfig {
    constructor(vals = {}) {
        this.name = "";
        this.workHourly = "";
        this.workHourlyDays = "";
        this.workMonthly = "";
        this.workMonthlyDays = "";
        this.overtimeHourly = "";
        this.overtimeMonthly = "";
        this.absenceHourly = new AbsenceAccountingSalaryConfig();
        this.absenceHourlyDays = new AbsenceAccountingSalaryConfig();
        this.absenceMonthly = new AbsenceAccountingSalaryConfig();
        this.absenceMonthlyDays = new AbsenceAccountingSalaryConfig();
        /** @deprecated */
        this.bonusTaxFree = new BonusAccountingSalaryConfig();
        /** @deprecated */
        this.bonusTaxed = new BonusAccountingSalaryConfig();
        this.commission = "";
        this.bonusAdvance = "";
        this.salary = "";
        this.payAdvance = "";
        this.employmentTypes = [];
        this.order = 0;
        this.mealsValue = "";
        this.mealsBreakfast = "";
        this.mealsLunch = "";
        this.mealsDinner = "";
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], AccountingSalaryConfig.prototype, "id", void 0);
__decorate([
    Type(() => CompanySettings),
    ManyToOne(() => CompanySettings),
    __metadata("design:type", CompanySettings)
], AccountingSalaryConfig.prototype, "settings", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "name", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workHourly", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workHourlyDays", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workMonthly", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "workMonthlyDays", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "overtimeHourly", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "overtimeMonthly", void 0);
__decorate([
    Type(() => AbsenceAccountingSalaryConfig),
    Column(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceHourly", void 0);
__decorate([
    Type(() => AbsenceAccountingSalaryConfig),
    Column(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceHourlyDays", void 0);
__decorate([
    Type(() => AbsenceAccountingSalaryConfig),
    Column(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceMonthly", void 0);
__decorate([
    Type(() => AbsenceAccountingSalaryConfig),
    Column(() => AbsenceAccountingSalaryConfig),
    __metadata("design:type", AbsenceAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "absenceMonthlyDays", void 0);
__decorate([
    Type(() => BonusAccountingSalaryConfig),
    Column(() => BonusAccountingSalaryConfig),
    __metadata("design:type", BonusAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "bonusTaxFree", void 0);
__decorate([
    Type(() => BonusAccountingSalaryConfig),
    Column(() => BonusAccountingSalaryConfig),
    __metadata("design:type", BonusAccountingSalaryConfig)
], AccountingSalaryConfig.prototype, "bonusTaxed", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "commission", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "bonusAdvance", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "salary", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "payAdvance", void 0);
__decorate([
    Column("simple-array"),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "employmentTypes", void 0);
__decorate([
    Column("jsonb", { default: [] }),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "entities", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], AccountingSalaryConfig.prototype, "order", void 0);
__decorate([
    OneToMany(() => AccountingSalaryConfigBonus, (bonus) => bonus.accountingSalaryConfig, {
        eager: true,
        cascade: true,
    }),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "bonuses", void 0);
__decorate([
    OneToMany(() => AccountingSalaryConfigBenefit, (benefit) => benefit.accountingSalaryConfig, {
        eager: true,
        cascade: true,
    }),
    __metadata("design:type", Array)
], AccountingSalaryConfig.prototype, "benefits", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsValue", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsBreakfast", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsLunch", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfig.prototype, "mealsDinner", void 0);
AccountingSalaryConfig = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], AccountingSalaryConfig);
export { AccountingSalaryConfig };
let CompanyEntity = class CompanyEntity {
    constructor(vals = {}) {
        this.name = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.archivedVenues = [];
        this.features = [Feature.Employees, Feature.Roster, Feature.Time];
        this.partnerIntegrations = [];
        this.isBetaCustomer = false;
        this.owner = undefined;
        this.billing = null;
        this.comments = "";
        Object.assign(this, vals);
    }
    get effectiveStatus() {
        return getEffectiveStatus(this.status, this.lifeCycleEvents || []);
    }
    getTimeSettings(context = {}) {
        const ctx = { ...context, company: this };
        return getTimeSettings(this.settings.availableTimeSettings, ctx);
    }
    getVenue(venueId) {
        return getVenue([...this.venues, ...this.archivedVenues], venueId);
    }
    getDepartment(id) {
        return getDepartment([...this.venues, ...this.archivedVenues], id);
    }
    getPositionColor(position) {
        return getPositionColor([...this.venues, ...this.archivedVenues], position);
    }
    getTimeEntryColor(entry) {
        return getTimeEntryColor(this.venues, this.archivedVenues, entry);
    }
    getTimeEntryTypeLabel(entry) {
        if (entry.position) {
            return entry.position.name;
        }
        return Localized[this.country].timeEntryTypeLabel(entry);
    }
    getPositionLabel(pos) {
        const position = typeof pos === "number" ? this.getPosition(pos)?.position : pos;
        if (!position) {
            return null;
        }
        const { venue, department } = this.getDepartment(position.departmentId);
        if (!venue || !department) {
            return position.name;
        }
        let label = `${department.name} / ${position.name}`;
        if (this.venues.length > 1) {
            label = `${venue.name} / ${label}`;
        }
        return label;
    }
    getPosition(id) {
        return getPosition(this.venues, this.archivedVenues, id);
    }
    isOwner(account) {
        const employee = this.employees.find((e) => e.accountId === account.id);
        return !!employee && employee.role === Role.Owner;
    }
    hasAccess(employee, context) {
        return (employee.role <= Role.Owner || matchesFilters(employee.access?.filters || [], { company: this, ...context }));
    }
    hasPermission(account, scope) {
        if (account.admin) {
            return true;
        }
        const employee = this.employees.find((e) => e.accountId === account.id);
        return !!employee && employee.hasPermission(scope);
    }
    getCostCenterForPosition(pos) {
        const position = typeof pos === "number" ? this.getPosition(pos)?.position : pos;
        if (!position) {
            return null;
        }
        const departments = [];
        const costCenter = this.costCenters?.find(({ entities }) => {
            for (const filter of entities) {
                // TODO: do we circumvent EntityFilters here? Why?
                if (filter.type === "venue") {
                    departments.push(...(this.venues.find((v) => v.id === filter.value)?.departments || []));
                }
                else if (filter.type === "department") {
                    const department = this.getDepartment(filter.value).department;
                    if (department) {
                        departments.push(department);
                    }
                }
            }
            return departments.some((dep) => dep.positions.some((pos) => pos.id === position.id));
        });
        return costCenter;
    }
    getCostCenter(context) {
        const ctx = { ...context, company: this };
        return getCostCenter(this.costCenters, ctx);
    }
    getWageTypeSet(employee, context) {
        return getWageTypeSet(employee, this.settings.accounting.salaryConfigs, { ...context, company: this });
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], CompanyEntity.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CompanyEntity.prototype, "name", void 0);
__decorate([
    Column("varchar", { default: "DE" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "country", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "address", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "city", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "postalCode", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "email", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "phone", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], CompanyEntity.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], CompanyEntity.prototype, "updated", void 0);
__decorate([
    Type(() => Venue),
    OneToMany(() => Venue, (v) => v.company, { eager: false }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "venues", void 0);
__decorate([
    Type(() => Venue),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "archivedVenues", void 0);
__decorate([
    Type(() => Employee),
    OneToMany(() => Employee, (v) => v.company, { eager: false }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "employees", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], CompanyEntity.prototype, "settingsId", void 0);
__decorate([
    Type(() => CompanySettings),
    OneToOne(() => CompanySettings, { eager: false, cascade: false }),
    JoinColumn(),
    __metadata("design:type", CompanySettings)
], CompanyEntity.prototype, "settings", void 0);
__decorate([
    Column("simple-array", { default: "employees,roster,time" }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "features", void 0);
__decorate([
    Column("simple-array", { default: "" }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "partnerIntegrations", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], CompanyEntity.prototype, "isBetaCustomer", void 0);
__decorate([
    Type(() => Account),
    __metadata("design:type", Object)
], CompanyEntity.prototype, "owner", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], CompanyEntity.prototype, "billingId", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], CompanyEntity.prototype, "billingCustomerId", void 0);
__decorate([
    Type(() => BillingInfo),
    OneToOne(() => BillingInfo, { eager: false, cascade: true, nullable: true }),
    JoinColumn(),
    __metadata("design:type", Object)
], CompanyEntity.prototype, "billing", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "comments", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "secret", void 0);
__decorate([
    Column("varchar", { default: CompanyStatus.Active }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "status", void 0);
__decorate([
    OneToMany(() => CompanyLifeCycleEvent, (event) => event.company, { eager: false }),
    Type(() => CompanyLifeCycleEvent),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "lifeCycleEvents", void 0);
__decorate([
    Type(() => DocumentTag),
    OneToMany(() => DocumentTag, (tag) => tag.company, { eager: false }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "documentTags", void 0);
__decorate([
    Type(() => EmployeeTag),
    OneToMany(() => EmployeeTag, (tag) => tag.company, { eager: true }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "employeeTags", void 0);
__decorate([
    Type(() => BonusType),
    OneToMany(() => BonusType, (t) => t.company, { eager: true }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "bonusTypes", void 0);
__decorate([
    Type(() => BenefitType),
    OneToMany(() => BenefitType, (t) => t.company, { eager: true }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "benefitTypes", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "costCenters", void 0);
__decorate([
    Type(() => WageTypeDTO),
    OneToMany(() => WageType, (wt) => wt.company, { eager: false }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "wageTypes", void 0);
__decorate([
    Exclude(),
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], CompanyEntity.prototype, "_wageTypesOld", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], CompanyEntity.prototype, "apiKey", void 0);
CompanyEntity = __decorate([
    Entity({ name: "company" }),
    __metadata("design:paramtypes", [Object])
], CompanyEntity);
export { CompanyEntity };
let Venue = class Venue {
    constructor(vals = {}) {
        this.name = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.state = "BY";
        this.phone = "";
        this.order = 0;
        this.archivedDepartments = [];
        this.archived = false;
        this.accountingClient = null;
        this.accountingConsultant = null;
        this.cashbookLedger = null;
        this.realAccountsLength = null;
        this.mealValueLunch = null;
        this.mealValueDinner = null;
        Object.assign(this, vals);
    }
    get enabledHolidays() {
        return (this.holidays ||
            Object.values(HOLIDAYS)
                .flat()
                .filter((h) => h.states.includes(this.state))
                .filter((h) => !h.noRealHoliday)
                .map((h) => h.name));
    }
    get stateName() {
        const state = Object.values([Localized.AT.states, Localized.DE.states])
            .flat()
            .find((state) => state.code === this.state);
        return (state && state.name) || "";
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Venue.prototype, "id", void 0);
__decorate([
    Column({ type: "int", nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "venueNumber", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, (c) => c.venues, { onDelete: "CASCADE" }),
    Type(() => CompanyEntity),
    __metadata("design:type", CompanyEntity)
], Venue.prototype, "company", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Venue.prototype, "companyId", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Venue.prototype, "name", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Venue.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Venue.prototype, "updated", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Venue.prototype, "address", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Venue.prototype, "city", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Venue.prototype, "postalCode", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], Venue.prototype, "state", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Venue.prototype, "phone", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], Venue.prototype, "order", void 0);
__decorate([
    OneToMany(() => Department, (d) => d.venue, { eager: true }),
    Type(() => Department),
    __metadata("design:type", Array)
], Venue.prototype, "departments", void 0);
__decorate([
    Type(() => Department),
    __metadata("design:type", Array)
], Venue.prototype, "archivedDepartments", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], Venue.prototype, "archived", void 0);
__decorate([
    OneToMany(() => RosterTemplate, (t) => t.venue, { eager: true, cascade: true }),
    Type(() => RosterTemplate),
    __metadata("design:type", Array)
], Venue.prototype, "rosterTemplates", void 0);
__decorate([
    ManyToOne(() => TimeSettings, { eager: false, cascade: false, nullable: true, onDelete: "SET NULL" }),
    Type(() => TimeSettings),
    __metadata("design:type", Object)
], Venue.prototype, "timeSettings", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "timeSettingsId", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "holidays", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "accountingClient", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "accountingConsultant", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "cashbookLedger", void 0);
__decorate([
    Column("int", { nullable: true }),
    __metadata("design:type", Object)
], Venue.prototype, "realAccountsLength", void 0);
__decorate([
    Column("float", { nullable: true, default: null }),
    __metadata("design:type", Object)
], Venue.prototype, "mealValueBreakfast", void 0);
__decorate([
    Column("float", { nullable: true, default: null }),
    __metadata("design:type", Object)
], Venue.prototype, "mealValueLunch", void 0);
__decorate([
    Column("float", { nullable: true, default: null }),
    __metadata("design:type", Object)
], Venue.prototype, "mealValueDinner", void 0);
Venue = __decorate([
    Entity(),
    Unique(["companyId", "venueNumber"]),
    __metadata("design:paramtypes", [Object])
], Venue);
export { Venue };
let Department = class Department {
    constructor(vals = {}) {
        this.name = "";
        this.archivedPositions = [];
        this.order = 0;
        this.archived = false;
        this.rosterOrder = [];
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Department.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Department.prototype, "name", void 0);
__decorate([
    Column(),
    Index("IDX_department_venue_id", { unique: false }),
    __metadata("design:type", Number)
], Department.prototype, "venueId", void 0);
__decorate([
    ManyToOne(() => Venue, (v) => v.departments, { onDelete: "CASCADE" }),
    Type(() => Venue),
    __metadata("design:type", Venue)
], Department.prototype, "venue", void 0);
__decorate([
    OneToMany(() => Position, (position) => position.department, { eager: true, cascade: true }),
    Type(() => Position),
    __metadata("design:type", Array)
], Department.prototype, "positions", void 0);
__decorate([
    Type(() => Position),
    __metadata("design:type", Array)
], Department.prototype, "archivedPositions", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Department.prototype, "color", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], Department.prototype, "order", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Department.prototype, "archived", void 0);
__decorate([
    Column("simple-array", { default: "" }),
    __metadata("design:type", Array)
], Department.prototype, "rosterOrder", void 0);
__decorate([
    ManyToOne(() => TimeSettings, { eager: false, cascade: false, nullable: true, onDelete: "SET NULL" }),
    Type(() => TimeSettings),
    __metadata("design:type", Object)
], Department.prototype, "timeSettings", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Department.prototype, "timeSettingsId", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Department.prototype, "bonusesAreTaxed", void 0);
Department = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Department);
export { Department };
let Position = class Position {
    constructor(vals) {
        this.active = true;
        this.order = 0;
        if (vals) {
            if (vals.id) {
                this.id = vals.id;
            }
            this.name = vals.name || "";
            this.color = vals.color || "";
            if (typeof vals.order === "number") {
                this.order = vals.order;
            }
            if (vals.departmentId) {
                this.departmentId = vals.departmentId;
            }
        }
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Position.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Position.prototype, "name", void 0);
__decorate([
    Column(),
    Index("IDX_position_department_id", { unique: false }),
    __metadata("design:type", Number)
], Position.prototype, "departmentId", void 0);
__decorate([
    ManyToOne(() => Department, (dep) => dep.positions, { onDelete: "CASCADE" }),
    __metadata("design:type", Department)
], Position.prototype, "department", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], Position.prototype, "active", void 0);
__decorate([
    ManyToMany(() => Employee, (emp) => emp.positions),
    __metadata("design:type", Array)
], Position.prototype, "employees", void 0);
__decorate([
    ManyToMany(() => JobPosting, (posting) => posting.positions),
    __metadata("design:type", Array)
], Position.prototype, "jobPostings", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], Position.prototype, "order", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Position.prototype, "color", void 0);
Position = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Position);
export { Position };
let Employee = class Employee {
    constructor(vals = {}) {
        this.role = Role.Worker;
        this.access = null;
        this.firstName = "";
        this.lastName = "";
        this.deleted = null;
        this.title = "";
        this.callName = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.phone2 = "";
        this.birthday = null;
        this.birthCountry = "";
        this.nationality = "";
        this.taxId = "";
        this.socialSecurityNumber = "";
        this.notes = "";
        this.avatar = "";
        this.timePin = "";
        this.shiftTemplates = [];
        this.rosterTabs = [];
        this.notifications = defaultNotificationSettings;
        this.status = EmployeeStatus.Active;
        this.scheduledStatusChange = null;
        Object.assign(this, vals);
    }
    get name() {
        return getEmployeeName(this);
    }
    get currentContract() {
        return getCurrentContract(this.contracts || []);
    }
    get firstContract() {
        return getFirstContract(this.contracts || []);
    }
    // @TODO: rename to finalContract or something like that, it's not 100% clear what it is
    get latestContract() {
        return getLatestContract(this.contracts || []);
    }
    get employedInterval() {
        if (!this.contracts) {
            return null;
        }
        const today = toDateString(new Date());
        const sortedContracts = this.contracts.slice().sort((a, b) => (a.start < b.start ? -1 : 1));
        let earliestStart = null;
        let latestEnd = null;
        for (const contract of sortedContracts) {
            // ignore invalid contracts
            if (!contract.start)
                continue;
            // if contracts are starting in the future, we can stop
            if (today < contract.start) {
                break;
            }
            const start = parseDateString(contract.start);
            if (!earliestStart) {
                earliestStart = start;
            }
            // if there is a 365 days gap in contracts, we reset the earliest start
            if (latestEnd && start && start.getTime() - latestEnd.getTime() > 365 * day) {
                earliestStart = start;
            }
            // if contract has an end before today, we continue, otherwise we use today and stop
            if (contract.end && contract.end < today) {
                latestEnd = parseDateString(contract.end);
            }
            else {
                latestEnd = parseDateString(today);
                break;
            }
        }
        if (!earliestStart || !latestEnd) {
            return null;
        }
        return [earliestStart, latestEnd];
    }
    get active() {
        return this.status !== EmployeeStatus.Retired;
    }
    getAllContractsForRange(range) {
        return getAllContractsForRange(this.contracts || [], range);
    }
    getContractForRange(range) {
        return getContractForRange(this.contracts || [], range);
    }
    // TODO: This should not intake a string but a branded DateString type
    getContractForDate(date) {
        return this.contracts && getContractForDate(this.contracts, date);
    }
    hasPermission(scope) {
        return this.role <= Role.Owner || Boolean(this.access?.permissions?.includes(scope));
    }
    isBirthDay(date) {
        if (!this.birthday) {
            return false;
        }
        const d = date instanceof Date ? date : parseDateString(date);
        const bd = parseDateString(this.birthday);
        return bd && d && bd.getMonth() === d.getMonth() && bd.getDate() === d.getDate();
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Employee.prototype, "id", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "accountId", void 0);
__decorate([
    ManyToOne(() => Account, { nullable: true, onDelete: "SET NULL" }),
    Type(() => Account),
    __metadata("design:type", Object)
], Employee.prototype, "account", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], Employee.prototype, "companyId", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, (c) => c.employees, { onDelete: "CASCADE" }),
    __metadata("design:type", CompanyEntity)
], Employee.prototype, "company", void 0);
__decorate([
    Column("int", { default: Role.Worker }),
    __metadata("design:type", Number)
], Employee.prototype, "role", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "access", void 0);
__decorate([
    Column("integer", { nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "staffNumber", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "firstName", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "lastName", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Employee.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Employee.prototype, "updated", void 0);
__decorate([
    DeleteDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Object)
], Employee.prototype, "deleted", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "title", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "callName", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "address", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "city", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "postalCode", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "email", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "phone", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "phone2", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "birthday", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "birthName", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "birthCity", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "birthCountry", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "nationality", void 0);
__decorate([
    Column("varchar", { nullable: true }),
    __metadata("design:type", String)
], Employee.prototype, "gender", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "taxId", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "socialSecurityNumber", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "notes", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "avatar", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Employee.prototype, "timePin", void 0);
__decorate([
    Type(() => Position),
    ManyToMany(() => Position, (position) => position.employees, { eager: true }),
    JoinTable(),
    __metadata("design:type", Array)
], Employee.prototype, "positions", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], Employee.prototype, "positionsOrder", void 0);
__decorate([
    OneToMany(() => Contract, (contract) => contract.employee, { eager: true }),
    Type(() => Contract),
    __metadata("design:type", Array)
], Employee.prototype, "contracts", void 0);
__decorate([
    ManyToOne(() => TimeSettings, { eager: false, cascade: false, nullable: true, onDelete: "SET NULL" }),
    Type(() => TimeSettings),
    __metadata("design:type", Object)
], Employee.prototype, "timeSettings", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "timeSettingsId", void 0);
__decorate([
    Column("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], Employee.prototype, "shiftTemplates", void 0);
__decorate([
    Column("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], Employee.prototype, "rosterTabs", void 0);
__decorate([
    Column("jsonb", { default: JSON.stringify(defaultNotificationSettings) }),
    __metadata("design:type", Object)
], Employee.prototype, "notifications", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "invite", void 0);
__decorate([
    Column("simple-array", { default: Object.values(StaffAppFeature).join(",") }),
    __metadata("design:type", Array)
], Employee.prototype, "staffAppFeatures", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Employee.prototype, "isContactPerson", void 0);
__decorate([
    Column("varchar", { default: EmployeeStatus.Active }),
    __metadata("design:type", String)
], Employee.prototype, "status", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Employee.prototype, "scheduledStatusChange", void 0);
__decorate([
    OneToOne(() => EmployeePayrollData, (data) => data.employee),
    __metadata("design:type", EmployeePayrollData)
], Employee.prototype, "payrollData", void 0);
__decorate([
    ManyToMany(() => EmployeeTag, (tag) => tag.employees, { eager: true }),
    JoinTable(),
    Type(() => EmployeeTag),
    __metadata("design:type", Array)
], Employee.prototype, "tags", void 0);
Employee = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Employee);
export { Employee };
let Contract = class Contract {
    constructor(vals = {}) {
        this.end = null;
        this.nominalHoursMode = NominalHoursMode.WeekFactor;
        this.hoursPerWeek = 0;
        this.absenceHours = 0;
        this.annualTimeSheet = false;
        this.enableSFNLedger = false;
        this.sfnAdvance = 0;
        this.employmentType = EmploymentType.Regular;
        this.maxSalary = 0;
        this.vacationDays = 0;
        this.vacationIncrement = VacationIncrement.Monthly;
        /** @deprecated seemingly unused */
        this.bonusNight1 = 25;
        /** @deprecated seemingly unused */
        this.bonusNight2 = 40;
        /** @deprecated seemingly unused */
        this.bonusSunday = 50;
        /** @deprecated seemingly unused */
        this.bonusHoliday = 125;
        /** @deprecated seemingly unused */
        this.bonusSpecial = 0;
        /** @deprecated seemingly unused */
        this.stackBonuses = true;
        this.ignoreIssues = [];
        this.comment = "";
        this.blocked = false;
        // Similar to the contract end date, this is the first day after which the probation period ends.
        // When displaying the probation end date, we need to subtract 1 day to get the last day of the probation period.
        this.probationEnd = null;
        Object.defineProperty(this, "inclusiveEnd", {
            enumerable: true,
            get: () => this.end && dateAdd(this.end, { days: -1 }),
            set: (end) => (this.end = (end && dateAdd(end, { days: 1 })) || null),
        });
        Object.assign(this, vals);
    }
    get defaultSalary() {
        return getDefaultSalary(this.salaries);
    }
    get fixedWorkDays() {
        return hasFixedWorkDays(this.nominalHoursMode);
    }
    get probationInclusiveEnd() {
        return this.probationEnd ? dateAdd(this.probationEnd, { days: -1 }) : null;
    }
    set probationInclusiveEnd(probationEndDate) {
        this.probationEnd = (probationEndDate && dateAdd(probationEndDate, { days: 1 })) || null;
    }
    get nominalWeeklyHours() {
        return getNominalWeeklyHours({
            nominalHoursMode: this.nominalHoursMode,
            hoursPerWeek: this.hoursPerWeek,
            hoursPerDay: this.hoursPerDay,
        });
    }
    isActiveOn(date) {
        return isActiveOn(date, this);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Contract.prototype, "id", void 0);
__decorate([
    Column(),
    Index("IDX_contract_employee_id", { unique: false }),
    __metadata("design:type", Number)
], Contract.prototype, "employeeId", void 0);
__decorate([
    ManyToOne(() => Employee, (emp) => emp.contracts, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Contract.prototype, "employee", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Contract.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Contract.prototype, "updated", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], Contract.prototype, "start", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", Object)
], Contract.prototype, "end", void 0);
__decorate([
    Column("int", { default: NominalHoursMode.WeekFactor }),
    __metadata("design:type", Number)
], Contract.prototype, "nominalHoursMode", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], Contract.prototype, "hoursPerWeek", void 0);
__decorate([
    Column("simple-json", { nullable: true }),
    __metadata("design:type", Object)
], Contract.prototype, "hoursPerDay", void 0);
__decorate([
    Column("int", { default: AbsenceMode.Average }),
    __metadata("design:type", Number)
], Contract.prototype, "absenceMode", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], Contract.prototype, "absenceHours", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], Contract.prototype, "annualTimeSheet", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Contract.prototype, "enableSFNLedger", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], Contract.prototype, "sfnAdvance", void 0);
__decorate([
    Column("int", { default: EmploymentType.Regular }),
    __metadata("design:type", Number)
], Contract.prototype, "employmentType", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], Contract.prototype, "maxSalary", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], Contract.prototype, "vacationDays", void 0);
__decorate([
    Column("int"),
    __metadata("design:type", Number)
], Contract.prototype, "vacationIncrement", void 0);
__decorate([
    Column("float", { default: 25 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusNight1", void 0);
__decorate([
    Column("float", { default: 40 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusNight2", void 0);
__decorate([
    Column("float", { default: 50 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusSunday", void 0);
__decorate([
    Column("float", { default: 125 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusHoliday", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], Contract.prototype, "bonusSpecial", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], Contract.prototype, "stackBonuses", void 0);
__decorate([
    OneToMany(() => Salary, (salary) => salary.contract, { eager: true }),
    Type(() => Salary),
    __metadata("design:type", Array)
], Contract.prototype, "salaries", void 0);
__decorate([
    OneToMany(() => Bonus, (bonus) => bonus.contract, { eager: true }),
    Type(() => Bonus),
    __metadata("design:type", Array)
], Contract.prototype, "bonuses", void 0);
__decorate([
    OneToMany(() => Benefit, (benefit) => benefit.contract, { eager: true }),
    Type(() => Benefit),
    __metadata("design:type", Array)
], Contract.prototype, "benefits", void 0);
__decorate([
    Column("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], Contract.prototype, "ignoreIssues", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Contract.prototype, "comment", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Contract.prototype, "blocked", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", Object)
], Contract.prototype, "probationEnd", void 0);
Contract = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Contract);
export { Contract };
let Salary = class Salary {
    constructor(init = {}) {
        this.amount = 0;
        this.type = "hourly";
        this.commission = 0;
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Salary.prototype, "id", void 0);
__decorate([
    Column({ nullable: false }),
    __metadata("design:type", Number)
], Salary.prototype, "contractId", void 0);
__decorate([
    ManyToOne(() => Contract, (c) => c.salaries, { onDelete: "CASCADE" }),
    __metadata("design:type", Contract)
], Salary.prototype, "contract", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Salary.prototype, "positionId", void 0);
__decorate([
    ManyToOne(() => Position, { nullable: true, onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], Salary.prototype, "position", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], Salary.prototype, "amount", void 0);
__decorate([
    Column("varchar", { default: "hourly" }),
    __metadata("design:type", String)
], Salary.prototype, "type", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], Salary.prototype, "commission", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Salary.prototype, "accountingSalaryConfigId", void 0);
__decorate([
    ManyToOne(() => AccountingSalaryConfig, { nullable: true }),
    __metadata("design:type", Object)
], Salary.prototype, "accountingSalaryConfig", void 0);
Salary = __decorate([
    Entity(),
    Index(["contractId", "positionId"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], Salary);
export { Salary };
export { absenceTypes, isHalfDayEntry, timeEntryAbsenceTypes, TimeEntryType, timeEntryTypeColor, } from "./time-entries/time-entry-type";
const timeEntryPublishedDateProperties = ["time", "deleted", "startPlanned", "endPlanned"];
class DatePropertiesTransformer {
    constructor(properties) {
        this.properties = properties;
    }
    to(value) {
        if (!value) {
            // dts file generation
            return value;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const obj = { ...value };
        for (const key of this.properties) {
            if (obj[key] instanceof Date) {
                obj[key] = obj[key].toISOString();
            }
        }
        return obj;
    }
    from(value) {
        if (!value || typeof value !== "object") {
            return value;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const info = { ...value };
        for (const key of this.properties) {
            if (typeof info[key] === "string") {
                info[key] = new Date(info[key]);
            }
        }
        return info;
    }
}
let TimeEntry = class TimeEntry {
    constructor(vals = {}) {
        /** The date and time when the entity was created */
        this.created = new Date();
        /** The date and time when the entity was last updated */
        this.updated = new Date();
        /** The date and time when the entity was soft-deleted */
        this.deleted = null;
        /** If set, the entry is visible to the employee (roster publish, take/trade, spontaneous shift) */
        this.published = null;
        /** If set, the entry was seen in the staff app by the referenced employee */
        this.seen = null;
        /** The date and time when the entry was taken after being offered by an employee */
        this.taken = null;
        /** The date and time when the entry was offered by an employee */
        this.offered = null;
        /** The time the employee took a break */
        this.startBreak = null;
        /** The duration used to adjust the time balance of the employee. @see TimeEntryType.HourAdjustment */
        this.hours = null;
        /** The duration used to adjust the vacation balance of the employee. @see TimeEntryType.VacationAdjustment */
        this.days = null;
        /** Used to reset bonuses bonus balance of the employee. @see TimeEntryType.ResetLedgers */
        this.resetBonus = null;
        /** A comment for the time entry */
        this.comment = "";
        /** The type of the time entry.
         * Entries can either be shifts (TimeEntryType.Work), or be used for adjusting ledger balances of an employee */
        this.type = TimeEntryType.Work;
        /** The planned break duration */
        this.breakPlanned = null;
        /** Automatically applied breaks.  */
        this.breakAuto = null;
        /** The logged break duration */
        this.breakLogged = null;
        /** The final break duration, after applying time settings */
        this.break = null;
        /** Breakfast taken by the employee during the shift */
        this.mealsBreakfast = 0;
        /** Lunch taken by the employee during the shift */
        this.mealsLunch = 0;
        /** Dinner taken by the employee during the shift */
        this.mealsDinner = 0;
        /** Whether the employee will be paid for this entry, i.e. vacation or sick leave */
        this.paid = true;
        /** The revenue generated in this shift.  */
        this.revenue = 0;
        /** Pre-calculated actual values associated with this entry. */
        this.result = null;
        /** Pre-calculated planned values associated with this entry. */
        this.resultPlanned = null;
        /** Total costs from maximized time result. Used for savings report. */
        this.resultMaxTotalCosts = null;
        /** @deprecated */
        this.wageType = null;
        Object.assign(this, vals);
    }
    get planned() {
        return this.startPlanned && this.endPlanned && [this.startPlanned, this.endPlanned];
    }
    get logged() {
        return this.startLogged && this.endLogged && [this.startLogged, this.endLogged];
    }
    get final() {
        return this.startFinal && this.endFinal && [this.startFinal, this.endFinal];
    }
    get start() {
        return this.startFinal || this.startPlanned || new Date(this.date);
    }
    get end() {
        return this.endFinal || this.endPlanned || new Date(dateAdd(this.date, { days: 1 }));
    }
    get durationPlanned() {
        return ((this.planned && (this.planned[1].getTime() - this.planned[0].getTime()) / 3600 / 1000) || 0);
    }
    get durationLogged() {
        return ((this.logged && (this.logged[1].getTime() - this.logged[0].getTime()) / 3600 / 1000) || 0);
    }
    get durationFinal() {
        return ((this.final && (this.final[1].getTime() - this.final[0].getTime()) / 3600 / 1000) || 0);
    }
    get duration() {
        const interval = this.final || this.planned;
        return ((interval && (interval[1].getTime() - interval[0].getTime()) / 3600 / 1000) || 0);
    }
    get status() {
        if (this.type !== TimeEntryType.Work) {
            return "completed";
        }
        if (this.startFinal && this.endFinal) {
            return "completed";
        }
        else if (this.startBreak) {
            return "paused";
        }
        else if (this.startFinal) {
            return "ongoing";
        }
        else {
            return "scheduled";
        }
    }
    timeDisplay(mode) {
        switch (mode) {
            case "planned": {
                const start = this.startPlanned?.toTimeString().slice(0, 5) || "offen";
                const end = this.endPlanned?.toTimeString().slice(0, 5) || "offen";
                return `${start} - ${end}`;
            }
            case "active":
                return `${this.startFinal.toTimeString().slice(0, 5)} - offen`;
            case "complete":
                return `${this.startFinal.toTimeString().slice(0, 5)} - ${this.endFinal.toTimeString().slice(0, 5)}`;
        }
    }
    get info() {
        return {
            date: this.date,
            employeeId: this.employeeId,
            positionId: this.positionId ?? this.position?.id ?? null,
            startPlanned: this.startPlanned,
            endPlanned: this.endPlanned,
            deleted: this.deleted || null,
            comment: this.comment,
        };
    }
    matchesInfo({ date, employeeId, positionId, startPlanned, endPlanned, deleted, comment }) {
        return (this.date === date &&
            this.employeeId === employeeId &&
            this.positionId === positionId &&
            this.startPlanned?.getTime() === startPlanned?.getTime() &&
            this.endPlanned?.getTime() === endPlanned?.getTime() &&
            Boolean(this.deleted) === Boolean(deleted) &&
            this.comment === comment);
    }
    getChangedProps(info = this.published) {
        const changes = new Set();
        if (!info) {
            return changes;
        }
        for (const prop of ["date", "employeeId", "positionId", "comment"]) {
            if (this[prop] !== info[prop]) {
                changes.add(prop);
            }
        }
        if (this.startPlanned?.getTime() !== info.startPlanned?.getTime()) {
            changes.add("startPlanned");
        }
        if (this.endPlanned?.getTime() !== info.endPlanned?.getTime()) {
            changes.add("endPlanned");
        }
        if (Boolean(this.deleted) !== Boolean(info.deleted)) {
            changes.add("deleted");
        }
        return changes;
    }
    get isSeen() {
        return this.published && this.seen && this.matchesInfo(this.seen);
    }
    setSeen() {
        this.seen = {
            ...this.info,
            time: new Date(),
        };
    }
    get isPublished() {
        return this.published && this.matchesInfo(this.published);
    }
    setPublished() {
        this.published = {
            ...this.info,
            time: new Date(),
        };
        return this;
    }
    get isPast() {
        return this.date < toDateString(new Date());
    }
    matchesTimeFilter({ from, to, fromRule, toRule }) {
        return matchesTimeFilter(this, { from, to, fromRule, toRule });
    }
    overlapsWith(entry) {
        return entry.planned && this.planned && overlap(this.planned, [entry.planned]) > 0;
    }
};
__decorate([
    PrimaryColumn(),
    __metadata("design:type", String)
], TimeEntry.prototype, "id", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], TimeEntry.prototype, "created", void 0);
__decorate([
    Column(),
    Type(() => Date),
    __metadata("design:type", Date)
], TimeEntry.prototype, "updated", void 0);
__decorate([
    Column({ type: Date, nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "deleted", void 0);
__decorate([
    Column({
        type: "jsonb",
        nullable: true,
        transformer: new DatePropertiesTransformer(timeEntryPublishedDateProperties),
    }),
    TransformDateProperties(timeEntryPublishedDateProperties),
    __metadata("design:type", Object)
], TimeEntry.prototype, "published", void 0);
__decorate([
    Column({
        type: "jsonb",
        nullable: true,
        transformer: new DatePropertiesTransformer(timeEntryPublishedDateProperties),
    }),
    TransformDateProperties(timeEntryPublishedDateProperties),
    __metadata("design:type", Object)
], TimeEntry.prototype, "seen", void 0);
__decorate([
    Column({ type: Date, nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "taken", void 0);
__decorate([
    Column({ type: Date, nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "offered", void 0);
__decorate([
    ManyToOne(() => Position, { eager: true, nullable: true, onDelete: "SET NULL" }),
    Type(() => Position),
    __metadata("design:type", Object)
], TimeEntry.prototype, "position", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "positionId", void 0);
__decorate([
    ManyToOne(() => Employee, { eager: false, nullable: true, onDelete: "CASCADE" }),
    Type(() => Employee),
    __metadata("design:type", Object)
], TimeEntry.prototype, "employee", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "employeeId", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], TimeEntry.prototype, "date", void 0);
__decorate([
    Column("timestamptz", { nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startPlanned", void 0);
__decorate([
    Column("timestamptz", { nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endPlanned", void 0);
__decorate([
    Column("timestamptz", { nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startLogged", void 0);
__decorate([
    Column("timestamptz", { nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endLogged", void 0);
__decorate([
    Column("timestamptz", { nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startFinal", void 0);
__decorate([
    Column("timestamptz", { nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "endFinal", void 0);
__decorate([
    Column({ type: "timestamp", nullable: true }),
    Type(() => Date),
    __metadata("design:type", Object)
], TimeEntry.prototype, "startBreak", void 0);
__decorate([
    Column({ type: "float", nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "hours", void 0);
__decorate([
    Column({ type: "float", nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "days", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "resetBonus", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], TimeEntry.prototype, "comment", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], TimeEntry.prototype, "type", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "breakPlanned", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "breakAuto", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "breakLogged", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "break", void 0);
__decorate([
    Column("int", { default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "mealsBreakfast", void 0);
__decorate([
    Column("int", { default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "mealsLunch", void 0);
__decorate([
    Column("int", { default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "mealsDinner", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], TimeEntry.prototype, "paid", void 0);
__decorate([
    Column("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], TimeEntry.prototype, "ignoreIssues", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], TimeEntry.prototype, "revenue", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "result", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "resultPlanned", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "resultMaxTotalCosts", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], TimeEntry.prototype, "wageType", void 0);
TimeEntry = __decorate([
    Entity(),
    Index(["date"], { unique: false }),
    Index("IDX_time_entry_position_id", ["positionId"], { unique: false }),
    Index(["employeeId", "date"], { unique: false }),
    __metadata("design:paramtypes", [Object])
], TimeEntry);
export { TimeEntry };
let RosterTemplate = class RosterTemplate {
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], RosterTemplate.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RosterTemplate.prototype, "name", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], RosterTemplate.prototype, "created", void 0);
__decorate([
    Type(() => Venue),
    ManyToOne(() => Venue, (v) => v.rosterTemplates, { onDelete: "CASCADE", orphanedRowAction: "delete" }),
    __metadata("design:type", Venue)
], RosterTemplate.prototype, "venue", void 0);
__decorate([
    Column("simple-json"),
    __metadata("design:type", Array)
], RosterTemplate.prototype, "shifts", void 0);
RosterTemplate = __decorate([
    Entity()
], RosterTemplate);
export { RosterTemplate };
let RevenueGroup = class RevenueGroup {
    constructor(vals) {
        this.type = RevenueType.Other;
        this.name = "";
        this.taxKey = TaxKey.None;
        this.ledger = "";
        this.costCenter = "";
        this.cashbook = true;
        this.reporting = true;
        this.daily = true;
        this.attributions = [];
        this.order = null;
        this.postingKey = "";
        this.count = 0;
        this.amount = 0;
        if (vals) {
            Object.assign(this, vals);
        }
    }
    createEntry() {
        return new RevenueEntry({
            group: this,
            groupId: this.id,
            venueId: this.venueId,
            type: this.type,
            name: this.name,
            taxKey: this.taxKey,
            postingKey: this.postingKey,
            ledger: this.ledger,
            costCenter: this.costCenter,
            reporting: this.reporting,
            cashbook: this.cashbook,
        });
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], RevenueGroup.prototype, "id", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], RevenueGroup.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], RevenueGroup.prototype, "updated", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], RevenueGroup.prototype, "venueId", void 0);
__decorate([
    ManyToOne(() => Venue, { eager: false, onDelete: "CASCADE" }),
    __metadata("design:type", Venue)
], RevenueGroup.prototype, "venue", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], RevenueGroup.prototype, "type", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueGroup.prototype, "name", void 0);
__decorate([
    Column("int"),
    __metadata("design:type", Number)
], RevenueGroup.prototype, "taxKey", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueGroup.prototype, "ledger", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueGroup.prototype, "costCenter", void 0);
__decorate([
    Column("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueGroup.prototype, "cashbook", void 0);
__decorate([
    Column("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueGroup.prototype, "reporting", void 0);
__decorate([
    Column("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueGroup.prototype, "daily", void 0);
__decorate([
    Column("simple-json", { default: "[]" }),
    __metadata("design:type", Array)
], RevenueGroup.prototype, "attributions", void 0);
__decorate([
    Column("int", { nullable: true }),
    __metadata("design:type", Object)
], RevenueGroup.prototype, "order", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], RevenueGroup.prototype, "postingKey", void 0);
RevenueGroup = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], RevenueGroup);
export { RevenueGroup };
let RevenueEntry = RevenueEntry_1 = class RevenueEntry {
    constructor(vals) {
        this.name = "";
        this.type = RevenueType.Other;
        this.amount = 0;
        this.tip = 0;
        this.cashBalance = 0;
        this.taxKey = TaxKey.None;
        this.postingKey = "";
        this.ledger = "";
        this.costCenter = "";
        this.receipt = "";
        this.invoice = "";
        this.daily = false;
        this.draft = false;
        this.readonly = false;
        this.countingLog = null;
        this.paid = null;
        this.cashbook = true;
        this.reporting = true;
        if (vals) {
            Object.assign(this, vals);
        }
    }
    get text() {
        return this.name;
    }
    get cash() {
        switch (this.type) {
            case RevenueType.CashCount:
                return 0;
            case RevenueType.Debt:
                return add(this.amount, this.tip);
            // case RevenueType.Expense:
            // case RevenueType.Cashless:
            // case RevenueType.Debt:
            // case RevenueType.SalaryAdvance:
            //     return -this.amount;
            default:
                return this.amount;
        }
    }
    get revenue() {
        switch (this.type) {
            case RevenueType.Sales:
            case RevenueType.Expense:
                return this.amount;
            default:
                return 0;
        }
    }
    get attributions() {
        return (this.group && this.group.attributions) || [];
    }
    clone() {
        return new RevenueEntry_1({
            type: this.type,
            venueId: this.venueId,
            name: this.name,
            taxKey: this.taxKey,
            ledger: this.ledger,
            costCenter: this.costCenter,
            groupId: this.groupId,
        });
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "name", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], RevenueEntry.prototype, "type", void 0);
__decorate([
    Column("int", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "sequence", void 0);
__decorate([
    Column("int", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "subSequence", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], RevenueEntry.prototype, "date", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], RevenueEntry.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], RevenueEntry.prototype, "updated", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "amount", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "tip", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "cashBalance", void 0);
__decorate([
    Column("int"),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "taxKey", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], RevenueEntry.prototype, "postingKey", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "ledger", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "costCenter", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "receipt", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RevenueEntry.prototype, "invoice", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "venueId", void 0);
__decorate([
    ManyToOne(() => Venue, { onDelete: "CASCADE" }),
    __metadata("design:type", Venue)
], RevenueEntry.prototype, "venue", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "daily", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "draft", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "readonly", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], RevenueEntry.prototype, "employeeId", void 0);
__decorate([
    ManyToOne(() => Employee, { nullable: true, onDelete: "SET NULL" }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "employee", void 0);
__decorate([
    Column("simple-json", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "countingLog", void 0);
__decorate([
    Column("boolean", { nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "paid", void 0);
__decorate([
    Column("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "cashbook", void 0);
__decorate([
    Column("boolean", { default: true }),
    __metadata("design:type", Boolean)
], RevenueEntry.prototype, "reporting", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "groupId", void 0);
__decorate([
    ManyToOne(() => RevenueGroup, { nullable: true, eager: true }),
    __metadata("design:type", Object)
], RevenueEntry.prototype, "group", void 0);
RevenueEntry = RevenueEntry_1 = __decorate([
    Entity(),
    Index(["venueId", "date"], { unique: false }),
    __metadata("design:paramtypes", [Object])
], RevenueEntry);
export { RevenueEntry };
let RevenuePrediction = class RevenuePrediction {
    constructor(vals) {
        this.amount = 0;
        if (vals) {
            Object.assign(this, vals);
        }
    }
    get attributions() {
        return (this.group && this.group.attributions) || [];
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], RevenuePrediction.prototype, "id", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], RevenuePrediction.prototype, "date", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], RevenuePrediction.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], RevenuePrediction.prototype, "updated", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], RevenuePrediction.prototype, "amount", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], RevenuePrediction.prototype, "groupId", void 0);
__decorate([
    ManyToOne(() => RevenueGroup, { onDelete: "CASCADE", eager: true }),
    __metadata("design:type", RevenueGroup)
], RevenuePrediction.prototype, "group", void 0);
RevenuePrediction = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], RevenuePrediction);
export { RevenuePrediction };
let RosterTargets = class RosterTargets {
    constructor() {
        this.revenue = null;
        this.productivity = null;
        this.hours = null;
        this.default = false;
    }
    get weekDay() {
        return parseDateString(this.date).getDay();
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], RosterTargets.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], RosterTargets.prototype, "departmentId", void 0);
__decorate([
    ManyToOne(() => Department, { eager: false, onDelete: "CASCADE" }),
    __metadata("design:type", Department)
], RosterTargets.prototype, "department", void 0);
__decorate([
    Column({ type: "date" }),
    __metadata("design:type", String)
], RosterTargets.prototype, "date", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], RosterTargets.prototype, "revenue", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], RosterTargets.prototype, "productivity", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], RosterTargets.prototype, "hours", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], RosterTargets.prototype, "default", void 0);
RosterTargets = __decorate([
    Entity(),
    Index(["departmentId", "date"], { unique: true })
], RosterTargets);
export { RosterTargets };
let Absence = class Absence {
    constructor(vals = {}) {
        this.notes = "";
        this.request = null;
        this.response = null;
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Absence.prototype, "id", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], Absence.prototype, "type", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Absence.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Absence.prototype, "updated", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], Absence.prototype, "employeeId", void 0);
__decorate([
    ManyToOne(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Absence.prototype, "employee", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], Absence.prototype, "start", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], Absence.prototype, "end", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Absence.prototype, "notes", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], Absence.prototype, "status", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Absence.prototype, "request", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Absence.prototype, "response", void 0);
Absence = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Absence);
export { Absence };
let RosterNote = class RosterNote {
    constructor(vals = {}) {
        this.color = null;
        this.filters = [];
        this.displayAsRosterNote = true;
        this.vacationPolicy = VacationPolicy.AllowAll;
        Object.assign(this, vals);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], RosterNote.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], RosterNote.prototype, "text", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], RosterNote.prototype, "start", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], RosterNote.prototype, "end", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE" }),
    __metadata("design:type", CompanyEntity)
], RosterNote.prototype, "company", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], RosterNote.prototype, "companyId", void 0);
__decorate([
    Column({ type: "text", nullable: true }),
    __metadata("design:type", Object)
], RosterNote.prototype, "color", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], RosterNote.prototype, "filters", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], RosterNote.prototype, "displayAsRosterNote", void 0);
__decorate([
    Column("varchar", { default: VacationPolicy.AllowAll }),
    __metadata("design:type", String)
], RosterNote.prototype, "vacationPolicy", void 0);
RosterNote = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], RosterNote);
export { RosterNote };
export class GetEmployeeStatementsParams {
    constructor(vals = {}) {
        Object.assign(this, vals);
    }
}
__decorate([
    Type(() => CompanyEntity),
    __metadata("design:type", CompanyEntity)
], GetEmployeeStatementsParams.prototype, "company", void 0);
__decorate([
    Type(() => Employee),
    __metadata("design:type", Employee)
], GetEmployeeStatementsParams.prototype, "employee", void 0);
__decorate([
    Type(() => TimeEntry),
    __metadata("design:type", Array)
], GetEmployeeStatementsParams.prototype, "entries", void 0);
__decorate([
    Type(() => TimeEntry),
    __metadata("design:type", Array)
], GetEmployeeStatementsParams.prototype, "vacationEntries", void 0);
let CompanyLifeCycleEvent = class CompanyLifeCycleEvent {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], CompanyLifeCycleEvent.prototype, "id", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, (company) => company.lifeCycleEvents, {
        eager: false,
        nullable: false,
        onDelete: "CASCADE",
    }),
    __metadata("design:type", CompanyEntity)
], CompanyLifeCycleEvent.prototype, "company", void 0);
__decorate([
    Column({ nullable: false }),
    __metadata("design:type", Number)
], CompanyLifeCycleEvent.prototype, "companyId", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "comment", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], CompanyLifeCycleEvent.prototype, "created", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "createdBy", void 0);
__decorate([
    Column("varchar", { nullable: true }),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "status", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], CompanyLifeCycleEvent.prototype, "date", void 0);
CompanyLifeCycleEvent = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], CompanyLifeCycleEvent);
export { CompanyLifeCycleEvent };
let Availability = class Availability {
    constructor(init = {}) {
        this.start = null;
        this.end = null;
        this.status = AvailabilityStatus.Available;
        this.comment = "";
        this.repeats = Repeat.Never;
        Object.assign(this, init);
    }
    get icon() {
        return availabilityIcon(this.status);
    }
    get timeLabel() {
        return this.start && this.end
            ? `${this.start.slice(0, 5)} - ${this.end.slice(0, 5)}`
            : this.start
                ? `ab ${this.start.slice(0, 5)}`
                : this.end
                    ? `bis ${this.end.slice(0, 5)}`
                    : "";
    }
    get label() {
        return this.timeLabel || availabilityLabel(this.status);
    }
    get fullLabel() {
        return `${availabilityLabel(this.status)} ${this.timeLabel}`;
    }
    get color() {
        return availabilityColor(this.status);
    }
    get repeatsLabel() {
        return repeatsLabel(this.repeats);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Availability.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], Availability.prototype, "created", void 0);
__decorate([
    UpdateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], Availability.prototype, "updated", void 0);
__decorate([
    Column(),
    Index("IDX_availability_employee_id", { unique: false }),
    __metadata("design:type", Number)
], Availability.prototype, "employeeId", void 0);
__decorate([
    ManyToOne(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Availability.prototype, "employee", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], Availability.prototype, "date", void 0);
__decorate([
    Column("time", { nullable: true }),
    __metadata("design:type", Object)
], Availability.prototype, "start", void 0);
__decorate([
    Column("time", { nullable: true }),
    __metadata("design:type", Object)
], Availability.prototype, "end", void 0);
__decorate([
    Column("varchar", { default: AvailabilityStatus.Available }),
    __metadata("design:type", String)
], Availability.prototype, "status", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], Availability.prototype, "comment", void 0);
__decorate([
    Column("varchar", { default: Repeat.Never }),
    __metadata("design:type", String)
], Availability.prototype, "repeats", void 0);
Availability = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Availability);
export { Availability };
let Form = class Form {
    constructor(init = {}) {
        this.description = "";
        this.status = FormStatus.Draft;
        this.requiresEmployeeSignature = false;
        this.requiresManagerSignature = false;
        this.considerCaretakerSignatureIfUnderage = false;
        this.autoFinalize = false;
        Object.assign(this, init);
    }
    get fields() {
        return this.sections?.flatMap((section) => section.fields) || [];
    }
    checkCondition(condition) {
        return checkCondition(this.fields, condition);
    }
    prefillForEmployee(employee) {
        for (const field of this.fields) {
            const isEmployeeKey = (field) => field.mapsTo ? field.mapsTo.startsWith("employee.") : false;
            if (isEmployeeKey(field)) {
                const key = field.mapsTo.split(".")[1];
                const existing = employee[key];
                if (!existing) {
                    continue;
                }
                if (field.options && field.type === "string") {
                    const value = String(employee[key]);
                    const mapped = field.options.find((o) => o.value === value);
                    if (mapped) {
                        field.value = value;
                    }
                    continue;
                }
                switch (field.type) {
                    case "string":
                        field.value = String(employee[key]);
                        break;
                    case "date": {
                        const value = String(employee[key]);
                        if (parseDateString(value)) {
                            field.value = value;
                        }
                        break;
                    }
                    case "number":
                        field.value = Number(employee[key]);
                        break;
                    case "boolean":
                        field.value = Boolean(employee[key]);
                        break;
                }
            }
        }
    }
    getHumanReadableValue(field) {
        switch (field.type) {
            case "date":
                return formatDate(field.value);
            case "boolean":
                return field.value ? "Ja" : "Nein";
            default:
                return field.options?.find((o) => o.value === field.value)?.label || field.value;
        }
    }
    get requiresCaretakerSignature() {
        if (!this.considerCaretakerSignatureIfUnderage) {
            return false;
        }
        const birthdayStr = this.fields.find((field) => field.name === "birthday")?.value;
        //FIXME: somewhere null is assigned as default value
        if (!birthdayStr || typeof birthdayStr !== "string" || birthdayStr === "null") {
            return false;
        }
        return !isAdult(new Date(birthdayStr), new Date());
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Form.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Form.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Form.prototype, "description", void 0);
__decorate([
    ManyToOne(() => CompanyEntity),
    __metadata("design:type", CompanyEntity)
], Form.prototype, "company", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Form.prototype, "companyId", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Array)
], Form.prototype, "sections", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], Form.prototype, "status", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], Form.prototype, "requiresEmployeeSignature", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], Form.prototype, "requiresManagerSignature", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], Form.prototype, "considerCaretakerSignatureIfUnderage", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], Form.prototype, "autoFinalize", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Form.prototype, "managerSignature", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Form.prototype, "caretakerSignature", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Form.prototype, "employeeSignature", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], Form.prototype, "requiredConfirmations", void 0);
__decorate([
    CreateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], Form.prototype, "created", void 0);
__decorate([
    UpdateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], Form.prototype, "updated", void 0);
Form = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Form);
export { Form };
let Document = class Document {
    constructor(init = {}) {
        this.origin = DocumentOrigin.Manager;
        this.form = null;
        Object.assign(this, init);
    }
    get hideFromEmployee() {
        return this.tags.some((tag) => tag.hideFromEmployees);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Document.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Document.prototype, "uuid", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], Document.prototype, "companyId", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE" }),
    __metadata("design:type", CompanyEntity)
], Document.prototype, "company", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Document.prototype, "employeeId", void 0);
__decorate([
    ManyToOne(() => Employee, { onDelete: "CASCADE" }),
    __metadata("design:type", Employee)
], Document.prototype, "employee", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Document.prototype, "created", void 0);
__decorate([
    UpdateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], Document.prototype, "updated", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], Document.prototype, "createdById", void 0);
__decorate([
    ManyToOne(() => Employee, { onDelete: "SET NULL", nullable: true }),
    __metadata("design:type", Employee)
], Document.prototype, "createdBy", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Document.prototype, "name", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], Document.prototype, "type", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Document.prototype, "comment", void 0);
__decorate([
    Column("date"),
    __metadata("design:type", String)
], Document.prototype, "date", void 0);
__decorate([
    Column({ type: "enum", enum: DocumentOrigin, default: DocumentOrigin.Manager }),
    __metadata("design:type", String)
], Document.prototype, "origin", void 0);
__decorate([
    ManyToMany(() => DocumentTag, (tag) => tag.documents, { eager: true }),
    JoinTable(),
    Type(() => DocumentTag),
    __metadata("design:type", Array)
], Document.prototype, "tags", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Document.prototype, "url", void 0);
__decorate([
    Type(() => Form),
    OneToOne(() => Form, { nullable: true, eager: true, onDelete: "SET NULL" }),
    JoinColumn(),
    __metadata("design:type", Object)
], Document.prototype, "form", void 0);
Document = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Document);
export { Document };
let DocumentTag = class DocumentTag {
    constructor(init = {}) {
        this.order = 0;
        this.hideFromEmployees = false;
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], DocumentTag.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], DocumentTag.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], DocumentTag.prototype, "color", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", CompanyEntity)
], DocumentTag.prototype, "company", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], DocumentTag.prototype, "companyId", void 0);
__decorate([
    ManyToMany(() => Document, (tag) => tag.tags, { eager: false }),
    __metadata("design:type", Array)
], DocumentTag.prototype, "documents", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], DocumentTag.prototype, "order", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], DocumentTag.prototype, "hideFromEmployees", void 0);
DocumentTag = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], DocumentTag);
export { DocumentTag };
let JobPosting = class JobPosting {
    constructor(init = {}) {
        this.title = "";
        this.description = "";
        this.status = JobPostingStatus.Published;
        this.deleted = null;
        this.payType = "hourly";
        this.start = null;
        this.end = null;
        this.employmentType = EmploymentType.Regular;
        this.images = [];
        this.submissionConfirmationEmailTemplate = new EmailTemplate();
        this.rejectionEmailTemplate = new EmailTemplate();
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], JobPosting.prototype, "id", void 0);
__decorate([
    Column(),
    Index({ unique: true }),
    __metadata("design:type", String)
], JobPosting.prototype, "uuid", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], JobPosting.prototype, "title", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], JobPosting.prototype, "description", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", CompanyEntity)
], JobPosting.prototype, "company", void 0);
__decorate([
    Column("varchar", { default: JobPostingStatus.Published }),
    __metadata("design:type", String)
], JobPosting.prototype, "status", void 0);
__decorate([
    DeleteDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Object)
], JobPosting.prototype, "deleted", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], JobPosting.prototype, "companyId", void 0);
__decorate([
    ManyToOne(() => Venue, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", Venue)
], JobPosting.prototype, "venue", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], JobPosting.prototype, "venueId", void 0);
__decorate([
    Type(() => Position),
    ManyToMany(() => Position, (position) => position.jobPostings, { eager: true }),
    JoinTable(),
    __metadata("design:type", Array)
], JobPosting.prototype, "positions", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], JobPosting.prototype, "payType", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Number)
], JobPosting.prototype, "payAmount", void 0);
__decorate([
    Column("date", { nullable: true }),
    __metadata("design:type", Object)
], JobPosting.prototype, "start", void 0);
__decorate([
    Column("date", { nullable: true }),
    __metadata("design:type", Object)
], JobPosting.prototype, "end", void 0);
__decorate([
    Column("int"),
    __metadata("design:type", Number)
], JobPosting.prototype, "employmentType", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], JobPosting.prototype, "hoursPerWeek", void 0);
__decorate([
    Type(() => JobApplication),
    OneToMany(() => JobApplication, (v) => v.posting, { eager: true, cascade: ["soft-remove"] }),
    __metadata("design:type", Array)
], JobPosting.prototype, "applications", void 0);
__decorate([
    Column("jsonb"),
    __metadata("design:type", Array)
], JobPosting.prototype, "images", void 0);
__decorate([
    Column(() => EmailTemplate),
    __metadata("design:type", EmailTemplate)
], JobPosting.prototype, "submissionConfirmationEmailTemplate", void 0);
__decorate([
    Column(() => EmailTemplate),
    __metadata("design:type", EmailTemplate)
], JobPosting.prototype, "rejectionEmailTemplate", void 0);
__decorate([
    CreateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], JobPosting.prototype, "created", void 0);
__decorate([
    UpdateDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Date)
], JobPosting.prototype, "updated", void 0);
JobPosting = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], JobPosting);
export { JobPosting };
let JobApplication = class JobApplication {
    constructor(init = {}) {
        this.deleted = null;
        this.firstName = "";
        this.lastName = "";
        this.address = "";
        this.city = "";
        this.postalCode = "";
        this.email = "";
        this.phone = "";
        this.notes = "";
        this.headShot = "";
        this.message = "";
        this.documents = [];
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], JobApplication.prototype, "id", void 0);
__decorate([
    ManyToOne(() => JobPosting, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", JobPosting)
], JobApplication.prototype, "posting", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], JobApplication.prototype, "postingId", void 0);
__decorate([
    Column("varchar", { default: JobApplicationStatus.Open }),
    __metadata("design:type", String)
], JobApplication.prototype, "status", void 0);
__decorate([
    DeleteDateColumn({ type: "timestamptz" }),
    Type(() => Date),
    __metadata("design:type", Object)
], JobApplication.prototype, "deleted", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "firstName", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "lastName", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "address", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "city", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "postalCode", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "email", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "phone", void 0);
__decorate([
    Column({ type: "date", nullable: true }),
    __metadata("design:type", Object)
], JobApplication.prototype, "birthday", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "notes", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "headShot", void 0);
__decorate([
    Column("date", { nullable: true }),
    __metadata("design:type", Object)
], JobApplication.prototype, "availableFrom", void 0);
__decorate([
    CreateDateColumn(),
    Type(() => Date),
    __metadata("design:type", Date)
], JobApplication.prototype, "created", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], JobApplication.prototype, "message", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], JobApplication.prototype, "documents", void 0);
JobApplication = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], JobApplication);
export { JobApplication };
let BonusTypeOverride = class BonusTypeOverride {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], BonusTypeOverride.prototype, "id", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], BonusTypeOverride.prototype, "subjectId", void 0);
__decorate([
    ManyToOne("BonusType", { onDelete: "CASCADE", eager: false })
    // to avoid cyclical dependencies
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    __metadata("design:type", Object)
], BonusTypeOverride.prototype, "subject", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], BonusTypeOverride.prototype, "objectId", void 0);
__decorate([
    ManyToOne("BonusType", { onDelete: "CASCADE", eager: false })
    // to avoid cyclical dependencies
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    __metadata("design:type", Object)
], BonusTypeOverride.prototype, "object", void 0);
BonusTypeOverride = __decorate([
    Entity(),
    Index(["subjectId", "objectId"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], BonusTypeOverride);
export { BonusTypeOverride };
let BonusType = class BonusType {
    constructor(init = {}) {
        this.mode = BonusTypeMode.Daily;
        this.name = "";
        this.date = null;
        this.weekDays = null;
        this.holidays = null;
        this.intervals = [["00:00", "24:00"]];
        this.minDuration = null;
        this.minDurationPercent = null;
        this.shiftMustStartBefore = null;
        this.taxFree = true;
        this.continuedPay = false;
        this.compType = BonusCompType.ModifiedHourlyRate;
        /** @deprecated unused */
        this.archived = false;
        this.order = 0;
        Object.assign(this, init);
    }
    matchesDate(date, country) {
        switch (this.mode) {
            case BonusTypeMode.Daily:
                return true;
            case BonusTypeMode.Date:
                return date.endsWith(this.date);
            case BonusTypeMode.Holidays:
                return Boolean(getHolidayForDate(date, { holidays: this.holidays || undefined, country }));
            case BonusTypeMode.WeekDays:
                return this.weekDays?.includes(new Date(date).getDay());
        }
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], BonusType.prototype, "id", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", CompanyEntity)
], BonusType.prototype, "company", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], BonusType.prototype, "companyId", void 0);
__decorate([
    Column("varchar"),
    __metadata("design:type", String)
], BonusType.prototype, "mode", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], BonusType.prototype, "name", void 0);
__decorate([
    Column("text", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "date", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "weekDays", void 0);
__decorate([
    Column("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "holidays", void 0);
__decorate([
    Column("jsonb", { default: "[]" }),
    __metadata("design:type", Array)
], BonusType.prototype, "intervals", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "minDuration", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "minDurationPercent", void 0);
__decorate([
    Column("time", { nullable: true }),
    __metadata("design:type", Object)
], BonusType.prototype, "shiftMustStartBefore", void 0);
__decorate([
    Column("boolean", { default: true }),
    __metadata("design:type", Boolean)
], BonusType.prototype, "taxFree", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "taxFreeUpToRate", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], BonusType.prototype, "continuedPay", void 0);
__decorate([
    Column("varchar", { default: BonusCompType.ModifiedHourlyRate }),
    __metadata("design:type", String)
], BonusType.prototype, "compType", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "maxPercent", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "defaultPercent", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedHourlyRateMax", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedHourlyRateDefault", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedAmountMax", void 0);
__decorate([
    Column("float", { default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "fixedAmountDefault", void 0);
__decorate([
    OneToMany(() => BonusTypeOverride, (override) => override.subject, { eager: true, cascade: true }),
    __metadata("design:type", Array)
], BonusType.prototype, "overrides", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], BonusType.prototype, "archived", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], BonusType.prototype, "order", void 0);
__decorate([
    Column("varchar", { nullable: true }),
    __metadata("design:type", String)
], BonusType.prototype, "legalType", void 0);
BonusType = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], BonusType);
export { BonusType };
let Bonus = class Bonus {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Bonus.prototype, "id", void 0);
__decorate([
    Column({ nullable: false }),
    __metadata("design:type", Number)
], Bonus.prototype, "contractId", void 0);
__decorate([
    ManyToOne(() => Contract, (c) => c.bonuses, { onDelete: "CASCADE" }),
    __metadata("design:type", Contract)
], Bonus.prototype, "contract", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Bonus.prototype, "typeId", void 0);
__decorate([
    ManyToOne(() => BonusType, { onDelete: "CASCADE" }),
    __metadata("design:type", BonusType)
], Bonus.prototype, "type", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], Bonus.prototype, "percent", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Number)
], Bonus.prototype, "hourlyRate", void 0);
__decorate([
    Column("float", { nullable: true }),
    __metadata("design:type", Number)
], Bonus.prototype, "fixedAmount", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Object)
], Bonus.prototype, "positionId", void 0);
__decorate([
    ManyToOne(() => Position, { nullable: true, onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], Bonus.prototype, "position", void 0);
Bonus = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Bonus);
export { Bonus };
let AccountingSalaryConfigBonus = class AccountingSalaryConfigBonus {
    constructor(init = {}) {
        // The wage type number for the tax-free portion of this bonus (if applicable)
        this.taxFree = "";
        // The wage type number for the taxed portion of this bonus (if applicable)
        this.taxed = "";
        // The wage type number for this bonus on vacation days (always taxed)
        this.taxedVacation = "";
        // The wage type number for this bonus on sick days (always taxed)
        this.taxedSick = "";
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBonus.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBonus.prototype, "accountingSalaryConfigId", void 0);
__decorate([
    ManyToOne(() => AccountingSalaryConfig, { onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], AccountingSalaryConfigBonus.prototype, "accountingSalaryConfig", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBonus.prototype, "bonusTypeId", void 0);
__decorate([
    ManyToOne(() => BonusType, { onDelete: "CASCADE" }),
    __metadata("design:type", BonusType)
], AccountingSalaryConfigBonus.prototype, "bonusType", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfigBonus.prototype, "taxFree", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfigBonus.prototype, "taxed", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfigBonus.prototype, "taxedVacation", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSalaryConfigBonus.prototype, "taxedSick", void 0);
AccountingSalaryConfigBonus = __decorate([
    Entity(),
    Index(["accountingSalaryConfigId", "bonusTypeId"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], AccountingSalaryConfigBonus);
export { AccountingSalaryConfigBonus };
let BenefitType = class BenefitType {
    constructor(init = {}) {
        this.name = "";
        this.includeInMinimumWageComparison = false;
        this.includeInBonusPayments = false;
        this.taxFree = false;
        this.order = 0;
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], BenefitType.prototype, "id", void 0);
__decorate([
    ManyToOne(() => CompanyEntity, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", CompanyEntity)
], BenefitType.prototype, "company", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", Number)
], BenefitType.prototype, "companyId", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], BenefitType.prototype, "name", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], BenefitType.prototype, "includeInMinimumWageComparison", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], BenefitType.prototype, "includeInBonusPayments", void 0);
__decorate([
    Column({ default: false }),
    __metadata("design:type", Boolean)
], BenefitType.prototype, "taxFree", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], BenefitType.prototype, "order", void 0);
BenefitType = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], BenefitType);
export { BenefitType };
let Benefit = class Benefit {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Benefit.prototype, "id", void 0);
__decorate([
    Column({ nullable: false }),
    __metadata("design:type", Number)
], Benefit.prototype, "contractId", void 0);
__decorate([
    ManyToOne(() => Contract, (c) => c.salaries, { onDelete: "CASCADE" }),
    __metadata("design:type", Contract)
], Benefit.prototype, "contract", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Benefit.prototype, "typeId", void 0);
__decorate([
    ManyToOne(() => BenefitType, { onDelete: "RESTRICT" }),
    __metadata("design:type", BenefitType)
], Benefit.prototype, "type", void 0);
__decorate([
    Column("float"),
    __metadata("design:type", Number)
], Benefit.prototype, "amount", void 0);
Benefit = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], Benefit);
export { Benefit };
let AccountingSalaryConfigBenefit = class AccountingSalaryConfigBenefit {
    constructor(init = {}) {
        Object.assign(this, init);
    }
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBenefit.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBenefit.prototype, "accountingSalaryConfigId", void 0);
__decorate([
    ManyToOne(() => AccountingSalaryConfig, { onDelete: "CASCADE" }),
    __metadata("design:type", Object)
], AccountingSalaryConfigBenefit.prototype, "accountingSalaryConfig", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], AccountingSalaryConfigBenefit.prototype, "benefitTypeId", void 0);
__decorate([
    ManyToOne(() => BenefitType, { onDelete: "RESTRICT" }),
    __metadata("design:type", BenefitType)
], AccountingSalaryConfigBenefit.prototype, "benefitType", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], AccountingSalaryConfigBenefit.prototype, "wageTypeNumber", void 0);
AccountingSalaryConfigBenefit = __decorate([
    Entity(),
    __metadata("design:paramtypes", [Object])
], AccountingSalaryConfigBenefit);
export { AccountingSalaryConfigBenefit };
export * from "./model.embedded";
export * from "./model.functions";
export * from "./model.types";
//# sourceMappingURL=model.js.map